import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";

const PayPurposeTable = () => {
  const donations = useSelector((state) => state.donation?.donations || []);
const noOfDonations=donations.length;
  // Count Pay Purpose
  const counts = donations.reduce((acc, d) => {
    const key = d.payPurpose || "Unknown";   // your field name
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const rows = Object.keys(counts);
  const total = rows.reduce((sum, r) => sum + (counts[r] || 0), 0);

  return (
    <>
      <Box>
        <Typography variant="h6" sx={{ mb: 3 ,mt:5 ,fontWeight: "600"}}>No.of Donations:{noOfDonations}
                </Typography>
                <Typography variant="subtitle1" sx={{mb:1,fontWeight: "400" }}>Donation PayPurpose Summary
                </Typography>
      </Box>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr style={{ background: "#f0f0f0" }}>
            <th style={{ border: "1px solid #ddd", padding: "6px" }}>
              Pay Purpose
            </th>
            <th style={{ border: "1px solid #ddd", padding: "6px" }}>
              Count
            </th>
          </tr>
        </thead>

        <tbody>
          {rows.map((r) => (
            <tr key={r}>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>{r}</td>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                {counts[r]}
              </td>
            </tr>
          ))}

          <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>Total</td>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>{total}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default PayPurposeTable;